import { useEffect, useRef, useState } from 'react';

type UseStickButtonOptions = {
  enabled: boolean;
  isMobile: boolean;
};

export const useStickButton = ({ enabled, isMobile }: UseStickButtonOptions) => {
  const spaceRef = useRef<HTMLDivElement | null>(null);
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const [isStuck, setIsStuck] = useState(false);
  const [stuckTranslateX, setStuckTranslateX] = useState(0);

  useEffect(() => {
    if (!enabled || !isMobile) {
      setIsStuck(false);
      setStuckTranslateX(0);
      return;
    }

    const anchor = anchorRef.current;
    if (!anchor) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const isButtonStuck = !entry.isIntersecting;
        if (isButtonStuck && spaceRef.current) {
          const { left } = spaceRef.current.getBoundingClientRect();
          setStuckTranslateX(-left);
        }
        setIsStuck(isButtonStuck);
      },
      {
        root: null,
        threshold: 0,
      },
    );

    observer.observe(anchor);

    return () => {
      observer.disconnect();
    };
  }, [isMobile, enabled]);

  return { spaceRef, anchorRef, isStuck, stuckTranslateX };
};
